import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { DispatchRecordReport } from 'src/entities/DispatchRecord.entity';

export const DISPATCH_RECORDS_QUERY_KEY = 'dispatchRecords';

const fetchDispatchRecords = async (startOn: string, endOn: string): Promise<DispatchRecordReport> => {
  const query = new URLSearchParams();
  query.set('start_on', startOn);
  query.set('end_on', endOn);
  const res = await axios.get<DispatchRecordReport>(`/api/v5/reports/dispatch_records?${query.toString()}`);
  return res.data;
};

type Params = { startOn: string; endOn: string };

export const useDispatchRecordsQuery = ({ startOn, endOn }: Params) =>
  useQuery({
    queryKey: [DISPATCH_RECORDS_QUERY_KEY, startOn, endOn],
    queryFn: () => fetchDispatchRecords(startOn, endOn),
    enabled: Boolean(startOn) && Boolean(endOn),
    staleTime: Infinity
  });
